export const FAQS_I18N_ENTRIES = {
  faqs_Data1: {
    es: '<p>Genera vídeos/imágenes</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  faqs_Data2: {
    es: '<p>Graba los tramos de carretera que quieras incluir en tu inventario.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  faqs_Data3: {
    es: '<p>Súbelas a la plataforma</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  faqs_Data4: {
    es: '<p>Importa las imágenes en la plataforma y genera proyectos \n por ubicación y tramo.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  faqs_Data5: {
    es: '<p>Obtén un inventario detallado</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  faqs_Data6: {
    es: '<p>Obtén de forma automática y en cuestión de minutos toda la \n información relativa a los tramos generados</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  faqs_Data7: {
    es: '<p>Toma decisiones informadas</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  faqs_Data8: {
    es: '<p>Aprovecha todo el potencial de la información obtenida, realiza \n comparativas, genera informes y toma decisiones basadas en \n datos reales y actualizados.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  faqs_Data9: {
    es: '<p>Saber más</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
};
